/**
 * @fileoverview Entity Picker entity type section presentation component
 */
goog.declareModuleId('yext.ui.components.entitypicker.EntitySection');

import {EntityTypeModel} from '/ui/components/entitypicker/datasource/datamodel';
import {EntityIcon} from '/ui/components/entitypicker/itemlist/entityicon';
import {EntityTypeHeader} from '/ui/components/entitypicker/itemlist/entitytypeheader';

export class EntitySection extends React.Component {
  /**
   * @param {{
   *   type: !EntityTypeModel,
   *   icon: !EntityIcon,
   *   initialCollapsed: boolean,
   *   showHeader: boolean,
   *   selectAllHandler: ((function(): void)|undefined),
   * }} props
   */
  constructor(props) {
    super(props);

    this.state = {
      collapsed: this.props.initialCollapsed,
    };
    this.onSectionClick = this.onSectionClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.initialCollapsed != prevProps.initialCollapsed) {
      this.setState({collapsed: this.props.initialCollapsed});
    }
  }

  onSectionClick() {
    this.setState(state => ({collapsed: !state.collapsed}));
  }

  render() {
    let contentCssClass = 'uep-entity-section-contents';
    let headerCssClass = '';

    if (this.state.collapsed) {
      contentCssClass += ' uep-list-hidden';
    }

    if (this.state.collapsed || this.props.children.length === 0) {
      headerCssClass += ' uep-entity-section-collapsed';
    }

    if (this.props.children.length === 0) {
      headerCssClass += ' uep-entity-section-empty';
    }

    const sectionId = `uep-type-${this.props.type.id}`;
    const ariaAttributes = {
      'aria-controls': sectionId,
      'aria-expanded': !this.state.collapsed,
    };

    return (
      <div className="uep-entity-section">
        {this.props.showHeader
          && <EntityTypeHeader
            type={this.props.type}
            onClick={this.onSectionClick}
            onSelectAll={this.props.selectAllHandler}
            icon={this.props.icon}
            additionalCssClass={headerCssClass.trim()}
            additionalAttrs={ariaAttributes}
            usingEntities={true} />
        }
        <ul id={sectionId} className={contentCssClass}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}
